import { TeamMember } from 'lib/services/TeamMemberService';
import TertiaryHeroBanner from '@/components/Sections/Banners/TertieryHeroBanner';
import { useMemo } from 'react';

export const TeamMemberBanner: React.FC<{ teamMemberData: TeamMember }> = ({ teamMemberData }) => {
  const tertiaryHeroBannerProps = useMemo(
    () => ({
      fields: {
        title: {
          value: `${teamMemberData.firstName?.value || ''} ${teamMemberData.lastName?.value || ''}`,
        },
        subtitle: { value: teamMemberData.jobTitle?.value || '' },
      },
      rendering: {
        params: {
          background: 'background-primary',
        },
        componentName: 'TertiaryHeroBanner',
      },
    }),
    [
      teamMemberData.firstName?.value,
      teamMemberData.jobTitle?.value,
      teamMemberData.lastName?.value,
    ]
  );
  return <TertiaryHeroBanner {...tertiaryHeroBannerProps} />;
};
